import styled, { css } from "styled-components"
import { media } from "utils/Media"

const Text = styled('div')`
	font-family: ${props => props.theme.font.family.body};
	/* font-size: ${props => props.theme.font.size.base}; */
	&:focus, &:focus p {
		outline: 0 !important;
	}
	${props => props.title && css`
		font-family: ${props => props.theme.font.family.heading};
		//font-style: italic;
		font-weight: ${props => props.theme.font.weight.bold};
		background: ${props => props.theme.colors.titleGradient};
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		margin: 0;
		font-size: 1.875rem;
		text-transform: uppercase;
		@media ${media.md} {
			font-size: 2.5rem;
		}
		@media ${media.lg} {
			font-size: 3.5rem;
		}
		@media ${media.xl} {
			font-size: 4rem;
		}
		@media ${media.xxl} {
			font-size: 4.375rem;
		}
		${props => props.smaller && css`
			@media ${media.md} {
				font-size: 2.5rem;
			}
			@media ${media.lg} {
				font-size: 3rem;
			}
			@media ${media.xxl} {
				font-size: 4.375rem;
			}
		`}
  `}
	${props => props.$condensed && css`
		font-family: ${props => props.theme.font.family.condensed};
		font-weight: ${props => props.theme.font.weight.bold};
	`}
	${props => props.$heading && css`
		font-family: ${props => props.theme.font.family.heading};
		font-weight: ${props => props.theme.font.weight.bold};
	`}
	${props => props.$primary && css`
		color: ${props => props.theme.colors.primary};
	`}
	${props => props.$secondary && css`
		color: ${props => props.theme.colors.secondary};
	`}
	${props => props.$midBlue && css`
		color: ${props => props.theme.colors.midBlue};
	`}
	${props => props.$cyan && css`
		color: ${props => props.theme.colors.cyan};
	`}
	${props => props.$white && css`
		color: ${props => props.theme.colors.white};
	`}
	${props => props.$black && css`
		color: ${props => props.theme.colors.black};
	`}
	${props => props.$black && css`
		color: ${props => props.theme.colors.black};
	`}
	${props => props.$red && css`
		color: ${props => props.theme.colors.red};
	`}
	${props => props.$navy && css`
		color: ${props => props.theme.colors.navy};
	`}
	${props => props.$blackOff && css`
		color: ${props => props.theme.colors.blackOff};
	`}
	
	${props => props.$grey && css`
		color: ${props => props.theme.colors.grey};
	`}
	
	${props => props.$yellow && css`
		color: ${props => props.theme.colors.yellow};
	`}
	
	${props => props.$orange && css`
		color: ${props => props.theme.colors.secondary};
	`}
	
	${props => props.$bold && css`
		font-weight: ${props => props.theme.font.weight.bold};
	`}
	
	${props => props.$extrabold && css`
		font-family: ${props => props.theme.font.family.black};
	`}
	
	${props => props.$xxxl && css`
		font-size: ${props => props.theme.font.size.xxxl};
	
		@media ${media.$md} {
		}
	`}
	
	${props => props.$xxl && css`
		font-size: ${props => props.theme.font.size.xxl};
	
		@media ${media.$md} {
		}
	`}
	
	${props => props.$xl && css`
		font-size: ${props => props.theme.font.size.xl};
	
		@media ${media.$md} {
		}
	`}
	
	${props => props.$lg && css`
		font-size: ${props => props.theme.font.size.lg};
	`}
	${props => props.$xl && css`
		font-size: ${props => props.theme.font.size.xxl}!important;
	`}
	
	${props => props.$md && css`
		font-size: ${props => props.theme.font.size.md};
	`}
	
	${props => props.$sm && css`
	font-size: ${props => props.theme.font.size.sm};
	`}
	
	${props => props.$xs && css`
		font-size: ${props => props.theme.font.size.xs};
	`}
	
	${props => props.$size && css`
		font-size: ${props.size}rem;
	`}
	
	${props => props.$italic && css`
		//font-style: italic;
	`}
	
	${props => props.uppercase && css`
		text-transform: uppercase;
	`}
	
	${props => props.center && css`
		text-align: center;
	`}
	
	${props => props.$center && css`
		text-align: center;
	`}
	
	${props => props.right && css`
		text-align: right;
	`}
	${props => props.$countdown && css`
		font-family: ${props => props.theme.font.family.heading};
		font-size: ${props => props.theme.font.size.base};
	`}
	${props => props.$baseheading && css`
		font-family: ${props => props.theme.font.family.heading};
		font-size: ${props => props.theme.font.size.xl};
		//font-style: italic;
	`}
	${props => props.$baseSubtitle && css`
		font-family: ${props => props.theme.font.family.heading};
		font-weight: 500;
		font-size: ${props => props.theme.font.size.md};
		
	`}
	${props => props.$tabletMd && css`
		@media ${media.md} {
			font-size: ${props => props.theme.font.size.md};
		}
	`}
	${props => props.$heroText && css`
		/* color: #fff; */
		margin-bottom: 1.5rem;
		letter-spacing: 1.5px;
		font-size: ${props => props.theme.font.size.base};
		font-family: ${props => props.theme.font.family.black};
		font-weight: 700;
		@media ${media.md} {
			font-size: ${props => props.theme.font.size.lg};
			padding-left: 75px;
		}
		@media ${media.xl} {
			padding-left: 85px;
		}
	`}
	
	${props => props.$articleHeading && css`
		font-family: ${props => props.theme.font.family.heading};
		font-size: ${props => props.theme.font.size.xl};
		text-transform: uppercase;
		//font-style: italic;
		@media ${media.md} {
			font-size: ${props => props.theme.font.size.xxl};
		}
	`}
`

export default Text